module.exports = __webpack_public_path__ + "img/CAR_WASH_2.3f7efafc.jpg";